// Replacement for vue-observe-visibility's directive: the bound function is
// called with (isVisible, entry) whenever the element's visibility changes.
export default {
    mounted(el, { value }) {
        if (typeof value !== 'function') return
        el.__visibilityObserver__ = new IntersectionObserver((entries) => {
            entries.forEach((entry) => value(entry.isIntersecting, entry))
        })
        el.__visibilityObserver__.observe(el)
    },
    unmounted(el) {
        el.__visibilityObserver__?.disconnect()
        delete el.__visibilityObserver__
    },
}
